import {
    LucideCalculator,
    LucideCalendarCheck,
    LucideChartColumn,
    LucideChevronDown,
    LucideCreditCard,
    LucideDroplet,
    LucideFileText,
    LucideGrid2x2,
    LucideHouse,
    LucideLogIn,
    LucideMail,
    LucideMapPin,
    LucideMonitor,
    LucideSend,
    LucideShield,
    LucideWrench,
} from '@lucide/angular';

export const APP_LUCIDE_ICON_COMPONENTS = [
    LucideCalculator,
    LucideHouse,
    LucideGrid2x2,
    LucideChevronDown,
    LucideWrench,
    LucideCalendarCheck,
    LucideDroplet,
    LucideChartColumn,
    LucideCreditCard,
    LucideSend,
    LucideMonitor,
    LucideLogIn,
    LucideMail,
    LucideMapPin,
    LucideShield,
    LucideFileText,
] as const;

export const APP_LUCIDE_ICONS = {
    calculator: 'calculator',
    home: 'house',
    grid: 'grid-2x2',
    chevronDown: 'chevron-down',
    wrench: 'wrench',
    calendarCheck: 'calendar-check',
    droplet: 'droplet',
    chart: 'chart-column',
    creditCard: 'credit-card',
    send: 'send',
    monitor: 'monitor',
    logIn: 'log-in',
    mail: 'mail',
    mapPin: 'map-pin',
    shield: 'shield',
    fileText: 'file-text',
} as const;

export type AppLucideIconName = (typeof APP_LUCIDE_ICONS)[keyof typeof APP_LUCIDE_ICONS];
